import styled from "styled-components";

export const FieldInputWrapperBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    width: 100%;
`
